// extracted by mini-css-extract-plugin
export default {"innerWrapper":"gy-z","tooltipWrapper":"hy-z","icon":"iy-z","tooltip":"jy-z","content":"ky-z"};